import { render } from "./QuizAnswer.vue?vue&type=template&id=de900dea&ts=true"
import script from "./QuizAnswer.vue?vue&type=script&lang=ts"
export * from "./QuizAnswer.vue?vue&type=script&lang=ts"

import "./QuizAnswer.vue?vue&type=style&index=0&id=de900dea&lang=scss"

import exportComponent from "C:\\Users\\artur\\Documents\\CODELEX\\2 - CODELEX\\JOB SEARCH\\COMPANY ASSIGNMENTS\\Printful\\frontend-quiz\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__